export default {
    BACKEND_URL: {
        production: "https://api.crm.walter-learning.com",
        staging: "https://api.crm-stg.walter-learning.com",
        development: "http://localhost:8000"
        //development: "https://api.crm.walter-learning.com"
    },
    LMS_BACKEND_URL: {
        production: "https://api.app.walter-learning.com",
        staging: "https://api.app-stg.walter-learning.com",
        // development: "https://api.app.walter-learning.com"
        development: "http://localhost:8001"
    },
    LMS_FRONTEND_URL: {
        production: "https://app.walter-learning.com",
        staging: "https://app-stg.walter-learning.com",
        // development: "https://api.app.walter-learning.com"
        development: "http://localhost:3000"
    },
    WALTER_ASSISTANT_BACKEND_URL: {
        production: "https://api.assistant.ai.walter-learning.com",
        staging: "https://api.assistant.ai.walter-learning.com",
        //development: "https://api.assistant.ai.walter-learning.com"
        development: "http://localhost:8003"
    }
};
